import { SxProps, Theme } from '@mui/material';

export const SelectFieldStyles: SxProps<Theme> = (theme) => ({
    borderColor: theme.palette.grey[400],
});
